var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 141.123 161.322",
    viewBox: "0 0 141.123 161.322",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.673 34.825s8.695-16.475 20.136-25.17 22.425-16.475 30.662 0 8.238 20.494-25.399 32.9-25.399-7.73-25.399-7.73z",
    fill: "#2caf3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m66.629 35.825s-8.695-16.475-20.136-25.17-22.425-16.475-30.662 0-8.238 20.494 25.399 32.9 25.399-7.73 25.399-7.73z",
    fill: "#2caf3e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m84.132 39.67s12.784-8.495 19.656-11.531 22.053-7.031 22.852-5.913c.799 1.119-9.428 9.748-18.857 13.743s-25.78 8.629-25.78 8.629-1.227-2.004 2.129-4.928z",
    fill: "#358435"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m56.772 39.67s-12.784-8.495-19.656-11.531-22.053-7.031-22.852-5.913c-.799 1.119 9.428 9.748 18.857 13.743s25.78 8.629 25.78 8.629 1.227-2.004-2.129-4.928z",
    fill: "#358435"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m135.808 74.82h-130.493c-2.923 0-5.315-2.392-5.315-5.315v-21.595c0-2.923 2.392-5.315 5.315-5.315h130.493c2.923 0 5.315 2.392 5.315 5.315v21.595c0 2.923-2.392 5.315-5.315 5.315z",
    fill: "#d84444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m124.764 161.322h-109.226c-2.892 0-5.259-2.366-5.259-5.259v-92.097c0-2.892 2.366-5.259 5.259-5.259h109.226c2.892 0 5.259 2.366 5.259 5.259v92.097c0 2.893-2.366 5.259-5.259 5.259z",
    fill: "#d84444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m10.69 74.82h119.744v6.364h-119.744z",
    opacity: 0.28
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.1,
    cy: 38.572,
    fill: "#358435",
    rx: 12.848,
    ry: 10.021
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m54.773 42.594h31.578v118.728h-31.578z",
    fill: "#2caf3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.712f0c1d93f78baeb77e580e2d310d68.svg";
export { ForwardRef as ReactComponent };